import _implicitStylesheets from "./stats.css";
import _implicitScopedStylesheets from "./stats.scoped.css?scoped=true";
import _axImage from "ax/image";
import _axCard from "ax/card";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="axwp-stats__details${0}"${2}><h2 class="axwp-stats__title${0}"${2}>${"t2"}</h2><p class="axwp-stats__intro${0}"${2}>${"t4"}</p><div class="axwp-stats__main-stats${0}"${2}><div class="axwp-stats__main-stat${0}"${2}><p class="axwp-stats__main-stat-title${0}"${2}>${"t8"}</p><p class="axwp-stats__main-stat-string${0}"${2}>${"t10"}</p><p class="axwp-stats__main-stat-intro${0}"${2}>${"t12"}</p></div><div class="axwp-stats__main-stat${0}"${2}><p class="axwp-stats__main-stat-title${0}"${2}>${"t15"}</p><p class="axwp-stats__main-stat-string${0}"${2}>${"t17"}</p><p class="axwp-stats__main-stat-intro${0}"${2}>${"t19"}</p></div></div></div>`;
const $fragment2 = parseFragment`<div class="axwp-stats__bar__container${0}"${2}><p class="axwp-stats__bar-stat${0}"${2}><span class="axwp-stats__bar-stat-title${0}"${2}>${"t3"}</span><span class="axwp-stats__bar-stat-string${0}"${2}>${"t5"}</span><span class="axwp-stats__bar-stat-intro${0}"${2}>${"t7"}</span></p><p class="axwp-stats__bar-stat${0}"${2}><span class="axwp-stats__bar-stat-title${0}"${2}>${"t10"}</span><span class="axwp-stats__bar-stat-string${0}"${2}>${"t12"}</span><span class="axwp-stats__bar-stat-intro${0}"${2}>${"t14"}</span></p><p class="axwp-stats__bar-stat${0}"${2}><span class="axwp-stats__bar-stat-title${0}"${2}>${"t17"}</span><span class="axwp-stats__bar-stat-string${0}"${2}>${"t19"}</span><span class="axwp-stats__bar-stat-intro${0}"${2}>${"t21"}</span></p></div>`;
const stc0 = {
  classMap: {
    "axwp-stats": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "axwp-stats__container": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "axwp-stats__image": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "axwp-stats__bar": true
  },
  key: 6
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_element("div", stc0, [api_element("div", stc1, [api_element("div", stc2, [api_custom_element("ax-image", _axImage, {
    props: {
      "imgSrc": $cmp.image,
      "width": "100%",
      "height": "100%"
    },
    key: 3
  })]), api_static_fragment($fragment1, 5, [api_static_part(2, null, api_dynamic_text($cmp.mainTitle)), api_static_part(4, null, api_dynamic_text($cmp.intro)), api_static_part(8, null, api_dynamic_text($cmp.statOne)), api_static_part(10, null, api_dynamic_text($cmp.statOneString)), api_static_part(12, null, api_dynamic_text($cmp.statOneIntro)), api_static_part(15, null, api_dynamic_text($cmp.statTwo)), api_static_part(17, null, api_dynamic_text($cmp.statTwoString)), api_static_part(19, null, api_dynamic_text($cmp.statTwoIntro))]), $cmp.statBarEnabled ? api_custom_element("ax-card", _axCard, stc3, [api_static_fragment($fragment2, 8, [api_static_part(3, null, api_dynamic_text($cmp.statBarOne)), api_static_part(5, null, api_dynamic_text($cmp.statBarOneString)), api_static_part(7, null, api_dynamic_text($cmp.statBarOneIntro)), api_static_part(10, null, api_dynamic_text($cmp.statBarTwo)), api_static_part(12, null, api_dynamic_text($cmp.statBarTwoString)), api_static_part(14, null, api_dynamic_text($cmp.statBarTwoIntro)), api_static_part(17, null, api_dynamic_text($cmp.statBarThree)), api_static_part(19, null, api_dynamic_text($cmp.statBarThreeString)), api_static_part(21, null, api_dynamic_text($cmp.statBarThreeIntro))])]) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5l85ihdts2g";
tmpl.legacyStylesheetToken = "undefined-_stats";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
